import React from 'react';
import ParticlesBackground from './ParticlesBackground';
import TypewriterAuto from './TypewriterAuto';
import Counter from '../home/components/Counter';
import '../gral-stylesheets/header.scss';
import { IconBuilding, IconMoneyDollarCircleLine, IconUserGraduate, IconUserTie } from '../icons/icons';

import BlogHeader from '../blog/components/BlogHeader';



class Header extends React.Component {

  render() {
    let headerType = this.props.headerType;

    return (
      <>
        {
          headerType === 'unauthenticated' ?
            (
              <div className='header-home'>
                <div className='particles-container'>
                  <ParticlesBackground />
                </div>
                <div 
                  id='header-unauthenticated-animation'
                  className='header-unauthenticated-animation'
                  >
                  <div className='header-typewriter-container'>
                    <div
                      id='header-unauthenticated-title'
                      className='header-home-title'
                    >
                      <h2>Where job finds talent</h2>
                    </div>
                    <div
                      id='header-unauthenticated-typewriter'
                      className='header-home-typewriter'
                    >
                      <TypewriterAuto
                        textWriter={this.props.textWriter}
                      />
                    </div>
                    <div
                      id='header-unauthenticated-button'
                      className='button-join-container'
                    >
                      <button
                        className='button-join'
                        onClick={this.props.joinOpenHandle}
                      >
                        <h3>Join to DearHR</h3>
                      </button>
                    </div>
                  </div>
                </div>
                <div className='header-counter-bar'>
                  <Counter
                    options={[
                      { item: 'Talents', count: 48905, icon: <IconUserGraduate /> },
                      { item: 'Talents seekers', count: 2765, icon: <IconUserTie /> },
                      { item: 'Companies', count: 15, icon: <IconBuilding /> },
                      { item: 'Sponsor', count: 37, icon: <IconMoneyDollarCircleLine /> },
                    ]}
                  />
                </div>
              </div>
            )
            : headerType === 'about-us' ?
              (
                <div className='header-about-us'>
                  <div className='header-about-us-container'>
                    <div className='header-about-us-box'>
                      <h1>About DearHR</h1>
                      <h2>"Welcome to DearHR, the best network where talent seekers can intelligently connect with professionals, freelancers and services from anywhere in the world."</h2>
                    </div>
                  </div>
                </div>
              )
              : headerType === 'blog' ?
                <BlogHeader
                  images={this.props.images}
                  firstname={this.props.firstname}
                  textWriter={this.props.textWriter}
                />
                : ''
        }
      </>
    )
  }
}

export default Header;